// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"2e757b97","917":"447110f0","967":"500347c6"}[chunkId] + ".chunk.js";
};